import { useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const usePaginate = (params) => {

	const {defaultLimit = 10, baseRoute = "/loan"} = params ?? {defaultLimit:10, baseRoute:"/loan"};

	const router = useNavigate();
	const [searchParams] = useSearchParams();

	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(defaultLimit);

	const activePage = searchParams.get("page");
	const activeLimit = searchParams.get("limit");

	const updateQuery = useCallback((params = {}) => {
		const newParams = new URLSearchParams(searchParams);

		Object.entries(params).forEach(([key, value]) => {
			if (value !== undefined && value !== null) {
				newParams.set(key, value);
			}
		});

		router(`${baseRoute}?${newParams.toString()}`);
	}, [searchParams, baseRoute, router]);

	useEffect(() => {
		if (activePage) setPage(parseInt(activePage));
		if (activeLimit) setLimit(parseInt(activeLimit));
	}, [activePage, activeLimit]);

	return useMemo(() => ({
		page,
		limit,
		setPage: (newPage) => {
			updateQuery({ page: newPage });
			setPage(newPage);
		},
		setLimit: (newLimit) => {
			updateQuery({ limit: newLimit, page: page }); // keep current page
			setLimit(newLimit);
		},
		updateQuery, // exposed in case you want full control outside
	}), [page, limit, updateQuery]);
};
